// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AnvandarvillkorRouteImport } from './routes/anvandarvillkor'
import { Route as B96KorkortRouteImport } from './routes/b96-korkort'
import { Route as BesiktningHusbilRouteImport } from './routes/besiktning-husbil'
import { Route as BokaServiceRouteImport } from './routes/boka-service'
import { Route as BorsenRouteImport } from './routes/borsen'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DieselvarmareHusbilRouteImport } from './routes/dieselvarmare-husbil'
import { Route as ErfarenheterRouteImport } from './routes/erfarenheter'
import { Route as FaktaRouteImport } from './routes/fakta'
import { Route as FordonRouteImport } from './routes/fordon'
import { Route as FritidRouteImport } from './routes/fritid'
import { Route as FukttestHusbilRouteImport } from './routes/fukttest-husbil'
import { Route as HusbilBodenRouteImport } from './routes/husbil-boden'
import { Route as HusbilHaparandaRouteImport } from './routes/husbil-haparanda'
import { Route as HusbilKalixRouteImport } from './routes/husbil-kalix'
import { Route as HusbilLuleaRouteImport } from './routes/husbil-lulea'
import { Route as HusbilMatchningRouteImport } from './routes/husbil-matchning'
import { Route as HusbilNorrbottenRouteImport } from './routes/husbil-norrbotten'
import { Route as HusbilPiteaRouteImport } from './routes/husbil-pitea'
import { Route as HusbilResaRouteImport } from './routes/husbil-resa'
import { Route as HusbilarTillSaluRouteImport } from './routes/husbilar-till-salu'
import { Route as HusbilsdackRouteImport } from './routes/husbilsdack'
import { Route as HusbilsforsakringRouteImport } from './routes/husbilsforsakring'
import { Route as HusvagnKalixRouteImport } from './routes/husvagn-kalix'
import { Route as HusvagnarTillSaluRouteImport } from './routes/husvagnar-till-salu'
import { Route as IntegritetspolicyRouteImport } from './routes/integritetspolicy'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as KopvillkorRouteImport } from './routes/kopvillkor'
import { Route as LeasaHusbilRouteImport } from './routes/leasa-husbil'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MarknadRouteImport } from './routes/marknad'
import { Route as MedlemRouteImport } from './routes/medlem'
import { Route as OmOssRouteImport } from './routes/om-oss'
import { Route as OmdomenRouteImport } from './routes/omdomen'
import { Route as PrisindexRouteImport } from './routes/prisindex'
import { Route as PrisstatistikHusbilRouteImport } from './routes/prisstatistik-husbil'
import { Route as RapidoRouteImport } from './routes/rapido'
import { Route as ReservdelarRouteImport } from './routes/reservdelar'
import { Route as SaldaRouteImport } from './routes/salda'
import { Route as SaljaHusbilRouteImport } from './routes/salja-husbil'
import { Route as SolcellerHusbilRouteImport } from './routes/solceller-husbil'
import { Route as SparadeRouteImport } from './routes/sparade'
import { Route as StallplatserHusbilRouteImport } from './routes/stallplatser-husbil'
import { Route as TvattaHusvagnRouteImport } from './routes/tvatta-husvagn'
import { Route as VarderaHusbilRouteImport } from './routes/vardera-husbil'
import { Route as WebbkartaRouteImport } from './routes/webbkarta'
import { Route as AuthenticatedKontoRouteImport } from './routes/_authenticated.konto'
import { Route as AdminAnnonserRouteImport } from './routes/admin.annonser'
import { Route as AdminBloggRouteImport } from './routes/admin.blogg'
import { Route as AdminForumRouteImport } from './routes/admin.forum'
import { Route as AdminHalsaRouteImport } from './routes/admin.halsa'
import { Route as AdminInnehallRouteImport } from './routes/admin.innehall'
import { Route as AdminKunskapRouteImport } from './routes/admin.kunskap'
import { Route as AdminOmdomenRouteImport } from './routes/admin.omdomen'
import { Route as AdminPrisdatabasRouteImport } from './routes/admin.prisdatabas'
import { Route as BloggIndexRouteImport } from './routes/blogg.index'
import { Route as BloggSlugRouteImport } from './routes/blogg.$slug'
import { Route as ButikIndexRouteImport } from './routes/butik.index'
import { Route as ButikHandleRouteImport } from './routes/butik.$handle'
import { Route as CampingtipsIndexRouteImport } from './routes/campingtips.index'
import { Route as CampingtipsSlugRouteImport } from './routes/campingtips.$slug'
import { Route as FiIndexRouteImport } from './routes/fi.index'
import { Route as FiAsuntoautotRouteImport } from './routes/fi.asuntoautot'
import { Route as FiAsuntovaunutRouteImport } from './routes/fi.asuntovaunut'
import { Route as FiKosteusmittausRouteImport } from './routes/fi.kosteusmittaus'
import { Route as FiOstajanOpasRouteImport } from './routes/fi.ostajan-opas'
import { Route as FiRapidoRouteImport } from './routes/fi.rapido'
import { Route as FiTuontiRouteImport } from './routes/fi.tuonti'
import { Route as FiYhteystiedotRouteImport } from './routes/fi.yhteystiedot'
import { Route as FordonIdRouteImport } from './routes/fordon_.$id'
import { Route as ForumIndexRouteImport } from './routes/forum.index'
import { Route as ForumReglerRouteImport } from './routes/forum.regler'
import { Route as ForumSokRouteImport } from './routes/forum.sok'
import { Route as FuktrapportTokenRouteImport } from './routes/fuktrapport.$token'
import { Route as GuiderIndexRouteImport } from './routes/guider.index'
import { Route as GuiderSlugRouteImport } from './routes/guider.$slug'
import { Route as HusbilArsmodellArRouteImport } from './routes/husbil-arsmodell.$ar'
import { Route as HusbilTillSaluUnderPrisRouteImport } from './routes/husbil-till-salu-under.$pris'
import { Route as HusbilOrtRouteImport } from './routes/husbil.$ort'
import { Route as HusbilarBrandRouteImport } from './routes/husbilar.$brand'
import { Route as HusvagnarBrandRouteImport } from './routes/husvagnar.$brand'
import { Route as JamforIndexRouteImport } from './routes/jamfor.index'
import { Route as JamforSlugRouteImport } from './routes/jamfor.$slug'
import { Route as KunskapIndexRouteImport } from './routes/kunskap.index'
import { Route as KunskapSlugRouteImport } from './routes/kunskap.$slug'
import { Route as ModellerIndexRouteImport } from './routes/modeller.index'
import { Route as OrdlistaIndexRouteImport } from './routes/ordlista.index'
import { Route as OrdlistaTermRouteImport } from './routes/ordlista.$term'
import { Route as RapidoIndexRouteImport } from './routes/rapido.index'
import { Route as RapidoAterforsaljareRouteImport } from './routes/rapido.aterforsaljare'
import { Route as RapidoBegagnadeRouteImport } from './routes/rapido.begagnade'
import { Route as RapidoPrislistaRouteImport } from './routes/rapido.prislista'
import { Route as ReservdelarBrandRouteImport } from './routes/reservdelar_.$brand'
import { Route as SaldaSlugRouteImport } from './routes/salda_.$slug'
import { Route as TesterIndexRouteImport } from './routes/tester.index'
import { Route as TesterSlugRouteImport } from './routes/tester.$slug'
import { Route as VerktygAvskrivningHusbilRouteImport } from './routes/verktyg.avskrivning-husbil'
import { Route as VerktygBransleforbrukningHusbilRouteImport } from './routes/verktyg.bransleforbrukning-husbil'
import { Route as VerktygFuktprotokollRouteImport } from './routes/verktyg.fuktprotokoll'
import { Route as VerktygKorkortHusbilRouteImport } from './routes/verktyg.korkort-husbil'
import { Route as VerktygManadskostnadHusbilRouteImport } from './routes/verktyg.manadskostnad-husbil'
import { Route as VerktygPassarDenHosMigRouteImport } from './routes/verktyg.passar-den-hos-mig'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedCampingtipsNyRouteImport } from './routes/_authenticated.campingtips.ny'
import { Route as AuthenticatedForumBevakningarRouteImport } from './routes/_authenticated.forum.bevakningar'
import { Route as AuthenticatedForumNyttRouteImport } from './routes/_authenticated.forum.nytt'
import { Route as AuthenticatedKontoIndexRouteImport } from './routes/_authenticated.konto.index'
import { Route as AuthenticatedKontoMinaForfragningarRouteImport } from './routes/_authenticated.konto.mina-forfragningar'
import { Route as AuthenticatedKontoMinaTipsRouteImport } from './routes/_authenticated.konto.mina-tips'
import { Route as AuthenticatedKontoProfilRouteImport } from './routes/_authenticated.konto.profil'
import { Route as AuthenticatedKontoSakerhetRouteImport } from './routes/_authenticated.konto.sakerhet'
import { Route as BloggAmneTopicRouteImport } from './routes/blogg.amne.$topic'
import { Route as ForumKSlugRouteImport } from './routes/forum.k.$slug'
import { Route as ForumMedlemIdRouteImport } from './routes/forum.medlem.$id'
import { Route as ForumTSlugRouteImport } from './routes/forum.t.$slug'
import { Route as ForumTaggSlugRouteImport } from './routes/forum.tagg.$slug'
import { Route as HusbilOrtIndexRouteImport } from './routes/husbil.$ort.index'
import { Route as HusbilOrtModellRouteImport } from './routes/husbil.$ort.$modell'
import { Route as ModellerBrandSerieRouteImport } from './routes/modeller.$brand.$serie'
import { Route as RapidoGuiderSlugRouteImport } from './routes/rapido.guider.$slug'
import { Route as RapidoModellerModelRouteImport } from './routes/rapido.modeller.$model'
import { Route as ReservdelarKategoriSlugRouteImport } from './routes/reservdelar_.kategori.$slug'
import { Route as RapidoModellerModelYearRouteImport } from './routes/rapido.modeller.$model_.$year'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AnvandarvillkorRoute = AnvandarvillkorRouteImport.update({
            id: '/anvandarvillkor',path: '/anvandarvillkor',getParentRoute: () => rootRouteImport
          })
const B96KorkortRoute = B96KorkortRouteImport.update({
            id: '/b96-korkort',path: '/b96-korkort',getParentRoute: () => rootRouteImport
          })
const BesiktningHusbilRoute = BesiktningHusbilRouteImport.update({
            id: '/besiktning-husbil',path: '/besiktning-husbil',getParentRoute: () => rootRouteImport
          })
const BokaServiceRoute = BokaServiceRouteImport.update({
            id: '/boka-service',path: '/boka-service',getParentRoute: () => rootRouteImport
          })
const BorsenRoute = BorsenRouteImport.update({
            id: '/borsen',path: '/borsen',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DieselvarmareHusbilRoute = DieselvarmareHusbilRouteImport.update({
            id: '/dieselvarmare-husbil',path: '/dieselvarmare-husbil',getParentRoute: () => rootRouteImport
          })
const ErfarenheterRoute = ErfarenheterRouteImport.update({
            id: '/erfarenheter',path: '/erfarenheter',getParentRoute: () => rootRouteImport
          })
const FaktaRoute = FaktaRouteImport.update({
            id: '/fakta',path: '/fakta',getParentRoute: () => rootRouteImport
          })
const FordonRoute = FordonRouteImport.update({
            id: '/fordon',path: '/fordon',getParentRoute: () => rootRouteImport
          })
const FritidRoute = FritidRouteImport.update({
            id: '/fritid',path: '/fritid',getParentRoute: () => rootRouteImport
          })
const FukttestHusbilRoute = FukttestHusbilRouteImport.update({
            id: '/fukttest-husbil',path: '/fukttest-husbil',getParentRoute: () => rootRouteImport
          })
const HusbilBodenRoute = HusbilBodenRouteImport.update({
            id: '/husbil-boden',path: '/husbil-boden',getParentRoute: () => rootRouteImport
          })
const HusbilHaparandaRoute = HusbilHaparandaRouteImport.update({
            id: '/husbil-haparanda',path: '/husbil-haparanda',getParentRoute: () => rootRouteImport
          })
const HusbilKalixRoute = HusbilKalixRouteImport.update({
            id: '/husbil-kalix',path: '/husbil-kalix',getParentRoute: () => rootRouteImport
          })
const HusbilLuleaRoute = HusbilLuleaRouteImport.update({
            id: '/husbil-lulea',path: '/husbil-lulea',getParentRoute: () => rootRouteImport
          })
const HusbilMatchningRoute = HusbilMatchningRouteImport.update({
            id: '/husbil-matchning',path: '/husbil-matchning',getParentRoute: () => rootRouteImport
          })
const HusbilNorrbottenRoute = HusbilNorrbottenRouteImport.update({
            id: '/husbil-norrbotten',path: '/husbil-norrbotten',getParentRoute: () => rootRouteImport
          })
const HusbilPiteaRoute = HusbilPiteaRouteImport.update({
            id: '/husbil-pitea',path: '/husbil-pitea',getParentRoute: () => rootRouteImport
          })
const HusbilResaRoute = HusbilResaRouteImport.update({
            id: '/husbil-resa',path: '/husbil-resa',getParentRoute: () => rootRouteImport
          })
const HusbilarTillSaluRoute = HusbilarTillSaluRouteImport.update({
            id: '/husbilar-till-salu',path: '/husbilar-till-salu',getParentRoute: () => rootRouteImport
          })
const HusbilsdackRoute = HusbilsdackRouteImport.update({
            id: '/husbilsdack',path: '/husbilsdack',getParentRoute: () => rootRouteImport
          })
const HusbilsforsakringRoute = HusbilsforsakringRouteImport.update({
            id: '/husbilsforsakring',path: '/husbilsforsakring',getParentRoute: () => rootRouteImport
          })
const HusvagnKalixRoute = HusvagnKalixRouteImport.update({
            id: '/husvagn-kalix',path: '/husvagn-kalix',getParentRoute: () => rootRouteImport
          })
const HusvagnarTillSaluRoute = HusvagnarTillSaluRouteImport.update({
            id: '/husvagnar-till-salu',path: '/husvagnar-till-salu',getParentRoute: () => rootRouteImport
          })
const IntegritetspolicyRoute = IntegritetspolicyRouteImport.update({
            id: '/integritetspolicy',path: '/integritetspolicy',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const KopvillkorRoute = KopvillkorRouteImport.update({
            id: '/kopvillkor',path: '/kopvillkor',getParentRoute: () => rootRouteImport
          })
const LeasaHusbilRoute = LeasaHusbilRouteImport.update({
            id: '/leasa-husbil',path: '/leasa-husbil',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MarknadRoute = MarknadRouteImport.update({
            id: '/marknad',path: '/marknad',getParentRoute: () => rootRouteImport
          })
const MedlemRoute = MedlemRouteImport.update({
            id: '/medlem',path: '/medlem',getParentRoute: () => rootRouteImport
          })
const OmOssRoute = OmOssRouteImport.update({
            id: '/om-oss',path: '/om-oss',getParentRoute: () => rootRouteImport
          })
const OmdomenRoute = OmdomenRouteImport.update({
            id: '/omdomen',path: '/omdomen',getParentRoute: () => rootRouteImport
          })
const PrisindexRoute = PrisindexRouteImport.update({
            id: '/prisindex',path: '/prisindex',getParentRoute: () => rootRouteImport
          })
const PrisstatistikHusbilRoute = PrisstatistikHusbilRouteImport.update({
            id: '/prisstatistik-husbil',path: '/prisstatistik-husbil',getParentRoute: () => rootRouteImport
          })
const RapidoRoute = RapidoRouteImport.update({
            id: '/rapido',path: '/rapido',getParentRoute: () => rootRouteImport
          })
const ReservdelarRoute = ReservdelarRouteImport.update({
            id: '/reservdelar',path: '/reservdelar',getParentRoute: () => rootRouteImport
          })
const SaldaRoute = SaldaRouteImport.update({
            id: '/salda',path: '/salda',getParentRoute: () => rootRouteImport
          })
const SaljaHusbilRoute = SaljaHusbilRouteImport.update({
            id: '/salja-husbil',path: '/salja-husbil',getParentRoute: () => rootRouteImport
          })
const SolcellerHusbilRoute = SolcellerHusbilRouteImport.update({
            id: '/solceller-husbil',path: '/solceller-husbil',getParentRoute: () => rootRouteImport
          })
const SparadeRoute = SparadeRouteImport.update({
            id: '/sparade',path: '/sparade',getParentRoute: () => rootRouteImport
          })
const StallplatserHusbilRoute = StallplatserHusbilRouteImport.update({
            id: '/stallplatser-husbil',path: '/stallplatser-husbil',getParentRoute: () => rootRouteImport
          })
const TvattaHusvagnRoute = TvattaHusvagnRouteImport.update({
            id: '/tvatta-husvagn',path: '/tvatta-husvagn',getParentRoute: () => rootRouteImport
          })
const VarderaHusbilRoute = VarderaHusbilRouteImport.update({
            id: '/vardera-husbil',path: '/vardera-husbil',getParentRoute: () => rootRouteImport
          })
const WebbkartaRoute = WebbkartaRouteImport.update({
            id: '/webbkarta',path: '/webbkarta',getParentRoute: () => rootRouteImport
          })
const AuthenticatedKontoRoute = AuthenticatedKontoRouteImport.update({
            id: '/konto',path: '/konto',getParentRoute: () => AuthenticatedRoute
          })
const AdminAnnonserRoute = AdminAnnonserRouteImport.update({
            id: '/admin/annonser',path: '/admin/annonser',getParentRoute: () => rootRouteImport
          })
const AdminBloggRoute = AdminBloggRouteImport.update({
            id: '/admin/blogg',path: '/admin/blogg',getParentRoute: () => rootRouteImport
          })
const AdminForumRoute = AdminForumRouteImport.update({
            id: '/admin/forum',path: '/admin/forum',getParentRoute: () => rootRouteImport
          })
const AdminHalsaRoute = AdminHalsaRouteImport.update({
            id: '/admin/halsa',path: '/admin/halsa',getParentRoute: () => rootRouteImport
          })
const AdminInnehallRoute = AdminInnehallRouteImport.update({
            id: '/admin/innehall',path: '/admin/innehall',getParentRoute: () => rootRouteImport
          })
const AdminKunskapRoute = AdminKunskapRouteImport.update({
            id: '/admin/kunskap',path: '/admin/kunskap',getParentRoute: () => rootRouteImport
          })
const AdminOmdomenRoute = AdminOmdomenRouteImport.update({
            id: '/admin/omdomen',path: '/admin/omdomen',getParentRoute: () => rootRouteImport
          })
const AdminPrisdatabasRoute = AdminPrisdatabasRouteImport.update({
            id: '/admin/prisdatabas',path: '/admin/prisdatabas',getParentRoute: () => rootRouteImport
          })
const BloggIndexRoute = BloggIndexRouteImport.update({
            id: '/blogg/',path: '/blogg/',getParentRoute: () => rootRouteImport
          })
const BloggSlugRoute = BloggSlugRouteImport.update({
            id: '/blogg/$slug',path: '/blogg/$slug',getParentRoute: () => rootRouteImport
          })
const ButikIndexRoute = ButikIndexRouteImport.update({
            id: '/butik/',path: '/butik/',getParentRoute: () => rootRouteImport
          })
const ButikHandleRoute = ButikHandleRouteImport.update({
            id: '/butik/$handle',path: '/butik/$handle',getParentRoute: () => rootRouteImport
          })
const CampingtipsIndexRoute = CampingtipsIndexRouteImport.update({
            id: '/campingtips/',path: '/campingtips/',getParentRoute: () => rootRouteImport
          })
const CampingtipsSlugRoute = CampingtipsSlugRouteImport.update({
            id: '/campingtips/$slug',path: '/campingtips/$slug',getParentRoute: () => rootRouteImport
          })
const FiIndexRoute = FiIndexRouteImport.update({
            id: '/fi/',path: '/fi/',getParentRoute: () => rootRouteImport
          })
const FiAsuntoautotRoute = FiAsuntoautotRouteImport.update({
            id: '/fi/asuntoautot',path: '/fi/asuntoautot',getParentRoute: () => rootRouteImport
          })
const FiAsuntovaunutRoute = FiAsuntovaunutRouteImport.update({
            id: '/fi/asuntovaunut',path: '/fi/asuntovaunut',getParentRoute: () => rootRouteImport
          })
const FiKosteusmittausRoute = FiKosteusmittausRouteImport.update({
            id: '/fi/kosteusmittaus',path: '/fi/kosteusmittaus',getParentRoute: () => rootRouteImport
          })
const FiOstajanOpasRoute = FiOstajanOpasRouteImport.update({
            id: '/fi/ostajan-opas',path: '/fi/ostajan-opas',getParentRoute: () => rootRouteImport
          })
const FiRapidoRoute = FiRapidoRouteImport.update({
            id: '/fi/rapido',path: '/fi/rapido',getParentRoute: () => rootRouteImport
          })
const FiTuontiRoute = FiTuontiRouteImport.update({
            id: '/fi/tuonti',path: '/fi/tuonti',getParentRoute: () => rootRouteImport
          })
const FiYhteystiedotRoute = FiYhteystiedotRouteImport.update({
            id: '/fi/yhteystiedot',path: '/fi/yhteystiedot',getParentRoute: () => rootRouteImport
          })
const FordonIdRoute = FordonIdRouteImport.update({
            id: '/fordon_/$id',path: '/fordon/$id',getParentRoute: () => rootRouteImport
          })
const ForumIndexRoute = ForumIndexRouteImport.update({
            id: '/forum/',path: '/forum/',getParentRoute: () => rootRouteImport
          })
const ForumReglerRoute = ForumReglerRouteImport.update({
            id: '/forum/regler',path: '/forum/regler',getParentRoute: () => rootRouteImport
          })
const ForumSokRoute = ForumSokRouteImport.update({
            id: '/forum/sok',path: '/forum/sok',getParentRoute: () => rootRouteImport
          })
const FuktrapportTokenRoute = FuktrapportTokenRouteImport.update({
            id: '/fuktrapport/$token',path: '/fuktrapport/$token',getParentRoute: () => rootRouteImport
          })
const GuiderIndexRoute = GuiderIndexRouteImport.update({
            id: '/guider/',path: '/guider/',getParentRoute: () => rootRouteImport
          })
const GuiderSlugRoute = GuiderSlugRouteImport.update({
            id: '/guider/$slug',path: '/guider/$slug',getParentRoute: () => rootRouteImport
          })
const HusbilArsmodellArRoute = HusbilArsmodellArRouteImport.update({
            id: '/husbil-arsmodell/$ar',path: '/husbil-arsmodell/$ar',getParentRoute: () => rootRouteImport
          })
const HusbilTillSaluUnderPrisRoute = HusbilTillSaluUnderPrisRouteImport.update({
            id: '/husbil-till-salu-under/$pris',path: '/husbil-till-salu-under/$pris',getParentRoute: () => rootRouteImport
          })
const HusbilOrtRoute = HusbilOrtRouteImport.update({
            id: '/husbil/$ort',path: '/husbil/$ort',getParentRoute: () => rootRouteImport
          })
const HusbilarBrandRoute = HusbilarBrandRouteImport.update({
            id: '/husbilar/$brand',path: '/husbilar/$brand',getParentRoute: () => rootRouteImport
          })
const HusvagnarBrandRoute = HusvagnarBrandRouteImport.update({
            id: '/husvagnar/$brand',path: '/husvagnar/$brand',getParentRoute: () => rootRouteImport
          })
const JamforIndexRoute = JamforIndexRouteImport.update({
            id: '/jamfor/',path: '/jamfor/',getParentRoute: () => rootRouteImport
          })
const JamforSlugRoute = JamforSlugRouteImport.update({
            id: '/jamfor/$slug',path: '/jamfor/$slug',getParentRoute: () => rootRouteImport
          })
const KunskapIndexRoute = KunskapIndexRouteImport.update({
            id: '/kunskap/',path: '/kunskap/',getParentRoute: () => rootRouteImport
          })
const KunskapSlugRoute = KunskapSlugRouteImport.update({
            id: '/kunskap/$slug',path: '/kunskap/$slug',getParentRoute: () => rootRouteImport
          })
const ModellerIndexRoute = ModellerIndexRouteImport.update({
            id: '/modeller/',path: '/modeller/',getParentRoute: () => rootRouteImport
          })
const OrdlistaIndexRoute = OrdlistaIndexRouteImport.update({
            id: '/ordlista/',path: '/ordlista/',getParentRoute: () => rootRouteImport
          })
const OrdlistaTermRoute = OrdlistaTermRouteImport.update({
            id: '/ordlista/$term',path: '/ordlista/$term',getParentRoute: () => rootRouteImport
          })
const RapidoIndexRoute = RapidoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RapidoRoute
          })
const RapidoAterforsaljareRoute = RapidoAterforsaljareRouteImport.update({
            id: '/aterforsaljare',path: '/aterforsaljare',getParentRoute: () => RapidoRoute
          })
const RapidoBegagnadeRoute = RapidoBegagnadeRouteImport.update({
            id: '/begagnade',path: '/begagnade',getParentRoute: () => RapidoRoute
          })
const RapidoPrislistaRoute = RapidoPrislistaRouteImport.update({
            id: '/prislista',path: '/prislista',getParentRoute: () => RapidoRoute
          })
const ReservdelarBrandRoute = ReservdelarBrandRouteImport.update({
            id: '/reservdelar_/$brand',path: '/reservdelar/$brand',getParentRoute: () => rootRouteImport
          })
const SaldaSlugRoute = SaldaSlugRouteImport.update({
            id: '/salda_/$slug',path: '/salda/$slug',getParentRoute: () => rootRouteImport
          })
const TesterIndexRoute = TesterIndexRouteImport.update({
            id: '/tester/',path: '/tester/',getParentRoute: () => rootRouteImport
          })
const TesterSlugRoute = TesterSlugRouteImport.update({
            id: '/tester/$slug',path: '/tester/$slug',getParentRoute: () => rootRouteImport
          })
const VerktygAvskrivningHusbilRoute = VerktygAvskrivningHusbilRouteImport.update({
            id: '/verktyg/avskrivning-husbil',path: '/verktyg/avskrivning-husbil',getParentRoute: () => rootRouteImport
          })
const VerktygBransleforbrukningHusbilRoute = VerktygBransleforbrukningHusbilRouteImport.update({
            id: '/verktyg/bransleforbrukning-husbil',path: '/verktyg/bransleforbrukning-husbil',getParentRoute: () => rootRouteImport
          })
const VerktygFuktprotokollRoute = VerktygFuktprotokollRouteImport.update({
            id: '/verktyg/fuktprotokoll',path: '/verktyg/fuktprotokoll',getParentRoute: () => rootRouteImport
          })
const VerktygKorkortHusbilRoute = VerktygKorkortHusbilRouteImport.update({
            id: '/verktyg/korkort-husbil',path: '/verktyg/korkort-husbil',getParentRoute: () => rootRouteImport
          })
const VerktygManadskostnadHusbilRoute = VerktygManadskostnadHusbilRouteImport.update({
            id: '/verktyg/manadskostnad-husbil',path: '/verktyg/manadskostnad-husbil',getParentRoute: () => rootRouteImport
          })
const VerktygPassarDenHosMigRoute = VerktygPassarDenHosMigRouteImport.update({
            id: '/verktyg/passar-den-hos-mig',path: '/verktyg/passar-den-hos-mig',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedCampingtipsNyRoute = AuthenticatedCampingtipsNyRouteImport.update({
            id: '/campingtips/ny',path: '/campingtips/ny',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedForumBevakningarRoute = AuthenticatedForumBevakningarRouteImport.update({
            id: '/forum/bevakningar',path: '/forum/bevakningar',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedForumNyttRoute = AuthenticatedForumNyttRouteImport.update({
            id: '/forum/nytt',path: '/forum/nytt',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedKontoIndexRoute = AuthenticatedKontoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedKontoRoute
          })
const AuthenticatedKontoMinaForfragningarRoute = AuthenticatedKontoMinaForfragningarRouteImport.update({
            id: '/mina-forfragningar',path: '/mina-forfragningar',getParentRoute: () => AuthenticatedKontoRoute
          })
const AuthenticatedKontoMinaTipsRoute = AuthenticatedKontoMinaTipsRouteImport.update({
            id: '/mina-tips',path: '/mina-tips',getParentRoute: () => AuthenticatedKontoRoute
          })
const AuthenticatedKontoProfilRoute = AuthenticatedKontoProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => AuthenticatedKontoRoute
          })
const AuthenticatedKontoSakerhetRoute = AuthenticatedKontoSakerhetRouteImport.update({
            id: '/sakerhet',path: '/sakerhet',getParentRoute: () => AuthenticatedKontoRoute
          })
const BloggAmneTopicRoute = BloggAmneTopicRouteImport.update({
            id: '/blogg/amne/$topic',path: '/blogg/amne/$topic',getParentRoute: () => rootRouteImport
          })
const ForumKSlugRoute = ForumKSlugRouteImport.update({
            id: '/forum/k/$slug',path: '/forum/k/$slug',getParentRoute: () => rootRouteImport
          })
const ForumMedlemIdRoute = ForumMedlemIdRouteImport.update({
            id: '/forum/medlem/$id',path: '/forum/medlem/$id',getParentRoute: () => rootRouteImport
          })
const ForumTSlugRoute = ForumTSlugRouteImport.update({
            id: '/forum/t/$slug',path: '/forum/t/$slug',getParentRoute: () => rootRouteImport
          })
const ForumTaggSlugRoute = ForumTaggSlugRouteImport.update({
            id: '/forum/tagg/$slug',path: '/forum/tagg/$slug',getParentRoute: () => rootRouteImport
          })
const HusbilOrtIndexRoute = HusbilOrtIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HusbilOrtRoute
          })
const HusbilOrtModellRoute = HusbilOrtModellRouteImport.update({
            id: '/$modell',path: '/$modell',getParentRoute: () => HusbilOrtRoute
          })
const ModellerBrandSerieRoute = ModellerBrandSerieRouteImport.update({
            id: '/modeller/$brand/$serie',path: '/modeller/$brand/$serie',getParentRoute: () => rootRouteImport
          })
const RapidoGuiderSlugRoute = RapidoGuiderSlugRouteImport.update({
            id: '/guider/$slug',path: '/guider/$slug',getParentRoute: () => RapidoRoute
          })
const RapidoModellerModelRoute = RapidoModellerModelRouteImport.update({
            id: '/modeller/$model',path: '/modeller/$model',getParentRoute: () => RapidoRoute
          })
const ReservdelarKategoriSlugRoute = ReservdelarKategoriSlugRouteImport.update({
            id: '/reservdelar_/kategori/$slug',path: '/reservdelar/kategori/$slug',getParentRoute: () => rootRouteImport
          })
const RapidoModellerModelYearRoute = RapidoModellerModelYearRouteImport.update({
            id: '/modeller/$model_/$year',path: '/modeller/$model/$year',getParentRoute: () => RapidoRoute
          })





const AuthenticatedKontoRouteChildren = {
  AuthenticatedKontoMinaForfragningarRoute: AuthenticatedKontoMinaForfragningarRoute,AuthenticatedKontoMinaTipsRoute: AuthenticatedKontoMinaTipsRoute,AuthenticatedKontoProfilRoute: AuthenticatedKontoProfilRoute,AuthenticatedKontoSakerhetRoute: AuthenticatedKontoSakerhetRoute,AuthenticatedKontoIndexRoute: AuthenticatedKontoIndexRoute
}

const AuthenticatedKontoRouteWithChildren = AuthenticatedKontoRoute._addFileChildren(AuthenticatedKontoRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedKontoRoute: AuthenticatedKontoRouteWithChildren,AuthenticatedCampingtipsNyRoute: AuthenticatedCampingtipsNyRoute,AuthenticatedForumBevakningarRoute: AuthenticatedForumBevakningarRoute,AuthenticatedForumNyttRoute: AuthenticatedForumNyttRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const RapidoRouteChildren = {
  RapidoAterforsaljareRoute: RapidoAterforsaljareRoute,RapidoBegagnadeRoute: RapidoBegagnadeRoute,RapidoPrislistaRoute: RapidoPrislistaRoute,RapidoIndexRoute: RapidoIndexRoute,RapidoGuiderSlugRoute: RapidoGuiderSlugRoute,RapidoModellerModelRoute: RapidoModellerModelRoute,RapidoModellerModelYearRoute: RapidoModellerModelYearRoute
}

const RapidoRouteWithChildren = RapidoRoute._addFileChildren(RapidoRouteChildren)




const HusbilOrtRouteChildren = {
  HusbilOrtModellRoute: HusbilOrtModellRoute,HusbilOrtIndexRoute: HusbilOrtIndexRoute
}

const HusbilOrtRouteWithChildren = HusbilOrtRoute._addFileChildren(HusbilOrtRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AnvandarvillkorRoute: AnvandarvillkorRoute,B96KorkortRoute: B96KorkortRoute,BesiktningHusbilRoute: BesiktningHusbilRoute,BokaServiceRoute: BokaServiceRoute,BorsenRoute: BorsenRoute,CookiesRoute: CookiesRoute,DieselvarmareHusbilRoute: DieselvarmareHusbilRoute,ErfarenheterRoute: ErfarenheterRoute,FaktaRoute: FaktaRoute,FordonRoute: FordonRoute,FritidRoute: FritidRoute,FukttestHusbilRoute: FukttestHusbilRoute,HusbilBodenRoute: HusbilBodenRoute,HusbilHaparandaRoute: HusbilHaparandaRoute,HusbilKalixRoute: HusbilKalixRoute,HusbilLuleaRoute: HusbilLuleaRoute,HusbilMatchningRoute: HusbilMatchningRoute,HusbilNorrbottenRoute: HusbilNorrbottenRoute,HusbilPiteaRoute: HusbilPiteaRoute,HusbilResaRoute: HusbilResaRoute,HusbilarTillSaluRoute: HusbilarTillSaluRoute,HusbilsdackRoute: HusbilsdackRoute,HusbilsforsakringRoute: HusbilsforsakringRoute,HusvagnKalixRoute: HusvagnKalixRoute,HusvagnarTillSaluRoute: HusvagnarTillSaluRoute,IntegritetspolicyRoute: IntegritetspolicyRoute,KontaktRoute: KontaktRoute,KopvillkorRoute: KopvillkorRoute,LeasaHusbilRoute: LeasaHusbilRoute,LoginRoute: LoginRoute,MarknadRoute: MarknadRoute,MedlemRoute: MedlemRoute,OmOssRoute: OmOssRoute,OmdomenRoute: OmdomenRoute,PrisindexRoute: PrisindexRoute,PrisstatistikHusbilRoute: PrisstatistikHusbilRoute,RapidoRoute: RapidoRouteWithChildren,ReservdelarRoute: ReservdelarRoute,SaldaRoute: SaldaRoute,SaljaHusbilRoute: SaljaHusbilRoute,SolcellerHusbilRoute: SolcellerHusbilRoute,SparadeRoute: SparadeRoute,StallplatserHusbilRoute: StallplatserHusbilRoute,TvattaHusvagnRoute: TvattaHusvagnRoute,VarderaHusbilRoute: VarderaHusbilRoute,WebbkartaRoute: WebbkartaRoute,AdminAnnonserRoute: AdminAnnonserRoute,AdminBloggRoute: AdminBloggRoute,AdminForumRoute: AdminForumRoute,AdminHalsaRoute: AdminHalsaRoute,AdminInnehallRoute: AdminInnehallRoute,AdminKunskapRoute: AdminKunskapRoute,AdminOmdomenRoute: AdminOmdomenRoute,AdminPrisdatabasRoute: AdminPrisdatabasRoute,BloggSlugRoute: BloggSlugRoute,ButikHandleRoute: ButikHandleRoute,CampingtipsSlugRoute: CampingtipsSlugRoute,FiAsuntoautotRoute: FiAsuntoautotRoute,FiAsuntovaunutRoute: FiAsuntovaunutRoute,FiKosteusmittausRoute: FiKosteusmittausRoute,FiOstajanOpasRoute: FiOstajanOpasRoute,FiRapidoRoute: FiRapidoRoute,FiTuontiRoute: FiTuontiRoute,FiYhteystiedotRoute: FiYhteystiedotRoute,FordonIdRoute: FordonIdRoute,ForumReglerRoute: ForumReglerRoute,ForumSokRoute: ForumSokRoute,FuktrapportTokenRoute: FuktrapportTokenRoute,GuiderSlugRoute: GuiderSlugRoute,HusbilArsmodellArRoute: HusbilArsmodellArRoute,HusbilTillSaluUnderPrisRoute: HusbilTillSaluUnderPrisRoute,HusbilOrtRoute: HusbilOrtRouteWithChildren,HusbilarBrandRoute: HusbilarBrandRoute,HusvagnarBrandRoute: HusvagnarBrandRoute,JamforSlugRoute: JamforSlugRoute,KunskapSlugRoute: KunskapSlugRoute,OrdlistaTermRoute: OrdlistaTermRoute,ReservdelarBrandRoute: ReservdelarBrandRoute,SaldaSlugRoute: SaldaSlugRoute,TesterSlugRoute: TesterSlugRoute,VerktygAvskrivningHusbilRoute: VerktygAvskrivningHusbilRoute,VerktygBransleforbrukningHusbilRoute: VerktygBransleforbrukningHusbilRoute,VerktygFuktprotokollRoute: VerktygFuktprotokollRoute,VerktygKorkortHusbilRoute: VerktygKorkortHusbilRoute,VerktygManadskostnadHusbilRoute: VerktygManadskostnadHusbilRoute,VerktygPassarDenHosMigRoute: VerktygPassarDenHosMigRoute,BloggIndexRoute: BloggIndexRoute,ButikIndexRoute: ButikIndexRoute,CampingtipsIndexRoute: CampingtipsIndexRoute,FiIndexRoute: FiIndexRoute,ForumIndexRoute: ForumIndexRoute,GuiderIndexRoute: GuiderIndexRoute,JamforIndexRoute: JamforIndexRoute,KunskapIndexRoute: KunskapIndexRoute,ModellerIndexRoute: ModellerIndexRoute,OrdlistaIndexRoute: OrdlistaIndexRoute,TesterIndexRoute: TesterIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,BloggAmneTopicRoute: BloggAmneTopicRoute,ForumKSlugRoute: ForumKSlugRoute,ForumMedlemIdRoute: ForumMedlemIdRoute,ForumTSlugRoute: ForumTSlugRoute,ForumTaggSlugRoute: ForumTaggSlugRoute,ModellerBrandSerieRoute: ModellerBrandSerieRoute,ReservdelarKategoriSlugRoute: ReservdelarKategoriSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)